// Offline fronta (outbox) pro vybrané akce — když není připojení, uloží se a po
// obnovení se přehrají. Bezpečné jen pro idempotentní-ish akce (přechod fáze, poznámka).
type Method = 'POST' | 'PATCH';
interface QItem { id: string; method: Method; path: string; body: unknown; userId?: string | null }

const KEY = 'studio-os-outbox';
const listeners = new Set<() => void>();
let currentUser: string | null = null;
let onUserKnown: (() => void) | null = null;

// Kdo je přihlášený. Akce čekají na svého autora, cizí se neodešlou pod jeho jménem.
export function setOutboxUser(id: string | null) {
  currentUser = id;
  if (id) onUserKnown?.();
}
const mine = (it: QItem) => !it.userId || it.userId === currentUser;

const read = (): QItem[] => {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
};
const write = (q: QItem[]) => { localStorage.setItem(KEY, JSON.stringify(q)); listeners.forEach((l) => l()); };

export const outbox = {
  size: () => read().filter(mine).length,
  whenUserKnown: (fn: () => void) => { onUserKnown = fn; },
  subscribe: (fn: () => void) => { listeners.add(fn); return () => { listeners.delete(fn); }; },
  enqueue: (method: Method, path: string, body: unknown) => {
    write([...read(), { id: crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`, method, path, body, userId: currentUser }]);
  },
  // Vrací, co se opravdu stalo: co odešlo, co se odmítlo a co čeká na další pokus.
  async flush(): Promise<{ sent: number; refused: string[]; waiting: number }> {
    const q = read();
    const rest: QItem[] = [];
    const refused: string[] = [];
    let sent = 0;
    for (const it of q) {
      if (!currentUser || !mine(it)) { rest.push(it); continue; }
      try {
        // Klíč položky: když se odpověď ztratí a flush se zopakuje, server akci neprovede dvakrát.
        const r = await fetch(it.path, { method: it.method, credentials: 'same-origin', headers: { 'content-type': 'application/json', 'idempotency-key': it.id }, body: JSON.stringify(it.body) });
        if (r.ok) sent += 1;
        else if (r.status === 401 || r.status >= 500) rest.push(it); // po přihlášení / opravě znovu
        else refused.push(((await r.json().catch(() => null)) as { message?: string } | null)?.message ?? `HTTP ${r.status}`);
      } catch {
        rest.push(it);
      }
    }
    write(rest);
    return { sent, refused, waiting: rest.filter(mine).length };
  },
};

// Které cesty smí jít do offline fronty.
export const isQueueable = (path: string) => path.endsWith('/transition') || path === '/api/diary';
